import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TariffWizard from "../../components/tariff/wizard/TariffWizard";
import { WIZARD_STEPS } from "../../components/tariff/wizard/tariffWizardState";
import { useAuth } from "../../providers/AuthContext";
import { getCompleteTariff } from "../../api/Tariffs";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import LoadingTablePage from "../LoadingTablePage";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

const EditTariffWizardPage = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    const { getAccessToken } = useAuth();
    const [tariff, setTariff] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            try {
                const token = await getAccessToken();
                const full = await getCompleteTariff(id, token);
                setTariff(full);
            } catch (err) {
                toast.error(err?.message || t("toast.failedLoad", { entity: t("entity.tariff") }));
                navigate("/tariffs");
            }
            setLoading(false);
        };
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    if (loading || !tariff) {
        return (
            <>
                <HeaderBar />
                <div className="flex flex-row w-full">
                    <Sidebar />
                    <main className="page">
                        <LoadingTablePage title={t("entity.tariff")} loading={loading} />
                    </main>
                </div>
            </>
        );
    }

    return (
        <TariffWizard
            mode="edit"
            tariffPublicId={id}
            initialTariff={tariff}
            initialStep={WIZARD_STEPS.length - 1}
            onCancel={() => navigate("/tariffs")}
        />
    );
};

export default EditTariffWizardPage;
